import './sidebar.scss';
import {Link} from 'react-router-dom';
import { useState } from 'react';
import Logo from '../../assets/wehaulogo.png';

const Sidebar = ({setNavOpen, navOpen, track}) => {
    const [showRegLinks, setShowRegLinks] = useState(false);

    const handleShow = () => {
        setShowRegLinks(true);

    }

    const handleTrack = () => {
      track()
      setNavOpen(false)
    }

  return <div className='sidebar' id={navOpen ? "slideIn" : null}>
      <img src={Logo} alt="wehaul logo" />
      <ul className='main-links'>
            <Link onClick={() => setNavOpen(false)} to="" style={{textDecoration: "none", color: "#fff"}}><li><i className='fas fa-home'></i>Home</li></Link>
            <a href="https://blog.wehaul247.com" target="_blank" rel="noopener noreferrer"><li><i className='fas fa-file'></i>Blog</li></a>
            <Link onClick={handleTrack} to="" style={{textDecoration: "none", color: "#fff"}}> <li><i className='fas fa-list'></i>Track Delivery</li></Link>
            <Link onClick={() => setNavOpen(false)} to="/driver" style={{textDecoration: "none", color: "#fff"}}><li><i className='fas fa-user-tie'></i>Become a Driver</li></Link>
            <li onClick={() => setShowRegLinks(prev => !prev)}><i className='fas fa-lock'></i>Register/Login <i className="fas fa-angle-down" id={showRegLinks ? "rotated" : null}></i></li>
      </ul>
      {showRegLinks && <ul className="reg-links">
          <li onClick={() => window.location.href = "https://customer.wehaul247.com"}>For Customers</li>
          <li onClick={() => window.location.href = "https://driver.wehaul247.com"}>For Drivers</li>
          <li onClick={() => window.location.href = "https://enterprise.wehaul247.com"}>For Enterprise</li>
          <li onClick={() => window.location.href = "https://merchant.wehaul247.com"}>For Merchants</li>
      </ul>}
      <div className="middlex" style={{color: "#fff"}}>
        <p style={{width: "max-content",marginRight: "1rem"}} className="txt">Call us at:</p>
        <p style={{marginRight: "2rem", color: "#fff", width: "max-content"}} className="number">01-888-6060</p>
        <p style={{marginRight: "2rem", color: "#fff", width: "max-content"}} className="number">0916-0000-687</p>
      </div>
  </div>;
};

export default Sidebar;
